export default __webpack_public_path__ + "data-green-light.svg";